import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { useSpring, animated } from 'react-spring';
import { setStack } from '../REDUX/actions';
import _ from 'lodash';

const StackItem = props => {
  let { index, height, number, level, stack } = props;
  const stackCapacity = 14 - level;
  const top = index === stack.length - 2;
  const parked = index < stack.length - 1;
  const final = parked && !top;
  const stackFull = stack.length === stackCapacity;
  const row = stackCapacity - index - 1;
  const dy = row * height;

  let { color, background, opacity } = useSpring({
    color: `${final || stackFull ? 'rgb(220,220,220)' : 'rgb(0,255,0)'}`,
    background: `${final || stackFull ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.25)'}`,
    opacity: `${number === props.numberToRemove ? 0 : 1}`,
    onRest: () => {
      if (number === props.numberToRemove && _.find(props.stack, n => n === number)) {
        const descending = index === props.stack.length - 1 && props.stack[index] === number;

        props.stack.splice(index, 1);
        props.setStack(props.stack);

        if (descending) {
          props.pushItem();
        }
      }
    },
  });

  const transform = `translateY(${index < stack.length - 1 ? dy : props.drop}px)`;

  if (index === stack.length - 1 && number !== props.numberToRemove) {
    opacity = 1;
  }

  return (
    <animated.div
      className="nm-stack-item"
      style={{ height: `${height}px`, color, background, transform, opacity }}
      onClick={() => props.pushItem()}>
      {number}
    </animated.div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { setStack }
)(StackItem);
